import { Plus } from "lucide-react";

export default function AddButton({
  onClick,
  className = "",
  children = "Add",
}) {
  return (
    <button
      onClick={onClick}
      className={`
        relative z-30
	group
        overflow-hidden
        inline-flex
        items-center
        justify-center
        gap-2

        h-11
        px-5

        rounded-2xl
        border border-cyan-500/10

        bg-cyan-600
        text-white

        text-sm
        font-medium
        tracking-wide

        shadow-lg
        shadow-cyan-200/50

        transition-all
        duration-300
        ease-out

        hover:-translate-y-1
        hover:shadow-2xl
        hover:shadow-cyan-300/40
        hover:bg-cyan-700

        active:scale-[0.97]

        ${className}
      `}
    >
      {/* Glow Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-cyan-400/0 via-white/20 to-cyan-400/0 opacity-0 group-hover:opacity-100 group-hover:animate-[shine_1.5s_ease-in-out] pointer-events-none" />

      {/* Soft Glow */}
      <div className="absolute -inset-1 bg-cyan-400/20 blur-xl opacity-0 group-hover:opacity-100 transition duration-500 pointer-events-none" />

      {/* Icon */}
      <div className="relative z-10 flex items-center justify-center w-6 h-6 rounded-lg bg-white/15 group-hover:rotate-90 transition-transform duration-300">
        <Plus size={15} />
      </div>

      {/* Text */}
      <span className="relative z-10">
        {children}
      </span>
    </button>
  );
}
